// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"434":"882066df","543":"f79f4956"}[chunkId] + ".chunk.css";
};